export const emailVerificationRoutes = [
  {
    path: "verified",
    name: "verified",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "email-verification-verified" */ "@/views/auth/email-verification/email-verification-verified/index"
      )
  },
  {
    path: "invalid",
    name: "invalid",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "email-verification-invalid" */ "@/views/auth/email-verification/email-verification-invalid/index"
      )
  },
  {
    path: "success",
    name: "success",
    meta: { transitionName: "slide" },
    component: () =>
      import(
        /* webpackChunkName: "email-verification-success" */ "@/views/auth/email-verification/email-verification-success/index"
      )
  }
];
